module.exports = __webpack_public_path__ + "img/logo_siscure.8e91d9af.jpeg";